import { storeClient, endpoints, isGodUser } from '../api/client';

export async function loadStoreBrandNames(): Promise<string[]> {
  let names: string[] = [];
  if (isGodUser()) {
    const res = await storeClient.get(endpoints.storeAllBrandNames());
    names = (res?.data || []).filter(Boolean);
  } else {
    const res = await storeClient.get(endpoints.storeBrands());
    const items = res?.data?.items || res?.data?.content || res?.data || [];
    names = items.map((b: { name?: string }) => b.name).filter(Boolean);
  }
  return names.sort((a, b) => a.localeCompare(b));
}

export interface StoreCatalogProduct {
  name: string;
  keywords: string[];
  category?: string;
  identifier?: string;
}

export async function loadStoreProductsForBrand(brand: string): Promise<StoreCatalogProduct[]> {
  const res = await storeClient.get(endpoints.storeProductsByBrandName(brand, 0, 500));
  const items = res?.data?.items || res?.data?.content || res?.data || [];
  return items
    .map((p: any) => ({
      name: String(p.name || '').trim(),
      keywords: Array.isArray(p.keywords)
        ? p.keywords.map((k: unknown) => String(k).trim()).filter(Boolean)
        : [],
      category: p.category ? String(p.category) : undefined,
      identifier: p.identifier ? String(p.identifier) : undefined,
    }))
    .filter((p: StoreCatalogProduct) => p.name);
}
